import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isBeneficiary } from 'utils';
import { DownloadedItems } from './components/index';
import { FormField, TabsTimelineSub, Upload } from 'components';
import { flattenDocs } from './utils';
import DocsSupplier from './components/docsSupplier';
import { isEmpty, isNil } from 'lodash';
import { Empty, Col } from 'antd';
import { content} from './components/docsSupplier/content';
import { contentAdditional } from './components/docsSupplier/contentAdditional';

const DocumentsSupplier = () => {
  const docs = useSelector(state => state.forms.documents);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const flatDocs = flattenDocs(docs);
  const user = useSelector(state => state.user);
  const documents = useSelector(state => state.forms.documents);
  const docCheck = documents.supDespDeclar;
  const returnAuditorMessage = useSelector(state => state.forms.auditor.returnAuditorMessage);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.accepted";

  return !viewMode ? (
    <div>
      <div className="mt-4"/>
      <DocsSupplier group={'documents'} />
      {(isBeneficiary(user.groups) && activeTaskName === 'task.name.application_returned_to_supplier' && !viewMode) &&
          <div className='mt-5'>
            <Col className="gutter-row" span={12}>
                <FormField
                  label={'Σχόλιο Αξιολογητή'}
                  type='textarea'
                  disabled={true}
                  rows={6}
                  bold={true}
                  value={returnAuditorMessage}
                />
            </Col>
            <div className='mt-3'>
              {contentAdditional().map((item, index) => {
                return (
                  <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
                );
              })}
            </div>
          </div>
        }
      <div className="stepper-warning-message mt-3">
          <div>
            <p>Διευκρινήσεις:</p>
            <p>Συγκεκριμένα,  για εταιρίες εξωτερικού χωρίς παρουσία στην Ελλάδα δύναται να προσκομιστεί εναλλακτικό πιστοποιητικό ή βεβαίωση από το οικείο επιμελητήριο ή εμπορικό μητρώο ή άλλη αρμόδια αρχή ή Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου.</p>
            <p>Η εκπροσώπηση θα πρέπει να αποδεικνύεται με σαφή τρόπο.</p>
            <ul>
                <li>
                  Βεβαιώσεις και πιστοποιητικά που δεν έχουν συναχθεί στην ελληνική γλώσσα.
                </li>
                <li>
                  Τα αντίστοιχα έγγραφα θα πρέπει να συνοδεύονται από επίσημη μετάφραση στην ελληνική γλώσσα.
                </li>
            </ul>
          </div>
      </div>
    </div>
    
  ) 
    :
    (
    <>
      <div style={{minHeight:"500px"}}  >
        <div className="mt-4"/>
        {/* <DownloadedItems content={content_onlyNP} docs={flatDocs} />
        <DownloadedItems content={content_existCon} docs={flatDocs} /> */}
        {
          isEmpty(docCheck) ?
          <div style={{position:"absolute", top:"10%", left:"50%"}}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
          </div>
          :
          <>
            <DownloadedItems content={content()} docs={flatDocs} />
            <div className='mt-3'>
                {returnAuditorMessage && <Col className="gutter-row" span={12}>
                    <FormField
                      label={'Σχόλιο Αξιολογητή'}
                      type='textarea'
                      disabled={true}
                      rows={6}
                      bold={true}
                      value={returnAuditorMessage}
                    />
                </Col>}
                <div className='mt-3'>
                  <DownloadedItems content={contentAdditional()} docs={flatDocs} />
                </div>
            </div>
          </>
        }
      </div>
    </>
  );
};

DocumentsSupplier.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocumentsSupplier;
